import {
  createAction,
  createActionGroup,
  emptyProps,
  props,
} from '@ngrx/store';

import { VerifyUserDto } from '@fantaz/shared/data-access/api';
import { FantazUIError } from '@fantaz/shared/data-access/models';

export const init = createAction('[VerifyUser Page] Init');

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ~~~~~~~~~~~~~~~~~~~~~~~~~ Actions to Verify Process ~~~~~~~~~~~~~~~~~~~~~~~~~
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

export const verifyUser = createAction(
  '[VerifyUser/API] Verify User',
  props<{ user: VerifyUserDto }>(),
);

export const verifyUserSuccess = createAction(
  '[VerifyUser/API] Verify User Success',
  props<{ source: string; requireVerification?: boolean }>(),
);

export const verifyUserFailure = createAction(
  '[VerifyUser/API] Verify User Failure',
  props<{ error: FantazUIError; user?: VerifyUserDto }>(),
);

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ~~~~~~~~~~~~~~~~~~~~~~~~~ Actions to Handle Dialog ~~~~~~~~~~~~~~~~~~~~~~~~~~
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
export const openVerificationDialog = createAction(
  '[VerifyUser/Dialog] Open Verification Dialog',
  props<{ user?: Partial<VerifyUserDto>; attempts?: any }>(),
);

export const closeVerificationDialog = createAction(
  '[VerifyUser/Dialog] Close Verification Dialog',
);

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// ~~~~~~~~~~~~~~~~~~ Actions to Handle error by codes ~~~~~~~~~~~~~~~~~~~~~~~~~
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
export const showVerificationErrorMessage = createAction(
  '[VerifyUser/Page] Show Verification Error Message',
  props<{
    message: {
      title: string;
      content: string;
    };
    actions: { primaryAction: { label: string; handler: () => void } };
  }>(),
);
export const verifyUserFailureByEscalate = createAction(
  '[VerifyUser/Page] Open Message Dialog By Escalate',
  props<{ user: Partial<VerifyUserDto> }>(),
);

export const VerifyUserInBackground = createActionGroup({
  source: '[ VerifyUser/InBackground ]',
  events: {
    'Verify User': emptyProps(),
    'Verify User Success': (user: VerifyUserDto) => ({ user }),
    'Verify User Failure': (user: VerifyUserDto) => ({ user }),
  },
});

export const verifyUserSuggestion = createAction('/verify-user');

export const RequireVerificationAction = createActionGroup({
  source: '[VerifyUser/Page] Require Verification',
  events: {
    'Force KYC': (payload: { allowed: string[] }) => ({ payload }),
  },
});
